(function() {
  // Codes internes de l'app (règles de code cadeau, remises de la barre de
  // progression) : présents dans le panier mais jamais saisis par le client,
  // on ne les affiche pas en pastille.
  function getInternalCodes(instance) {
    const codes = new Set();
    (instance.ruleIdMapData || new Map()).forEach(rule => {
      if (rule && rule.name) codes.add(rule.name.toLowerCase());
    });
    Object.values(window.tlCartGoalRules || {}).forEach(rule => {
      ['product_discount', 'order_discount', 'shipping_discount'].forEach(key => {
        try {
          const discount = typeof rule[key] === 'string' ? JSON.parse(rule[key]) : rule[key];
          if (discount && discount.code) codes.add(discount.code.toLowerCase());
        } catch (e) {}
      });
    });
    return codes;
  }

  function patchTlDiscountCode(instance) {
    if (!instance || instance._shopifyDiscountPatched) return;
    instance._shopifyDiscountPatched = true;

    // 1. Patch getGiftAdded để giữ lại cả các mã Shopify trong danh sách discountCodeApplied
    const originalGetGiftAdded = instance.getGiftAdded;
    if (typeof originalGetGiftAdded === 'function') {
      instance.getGiftAdded = async function() {
        try {
          await originalGetGiftAdded.apply(this, arguments);
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const cartRes = await fetch(rootUrl + 'cart.js');
          if (cartRes.ok) {
            const cartData = await cartRes.json();
            if (cartData && Array.isArray(cartData.discount_codes)) {
              const internalCodes = getInternalCodes(this);
              this.discountCodeApplied = cartData.discount_codes
                .filter(item => item.applicable && !internalCodes.has(item.code.toLowerCase()))
                .map(item => item.code);
            }
          }
        } catch (err) {
          console.warn('[TL Discount Patch] getGiftAdded error:', err);
        }
      };
    }

    // 2. Patch handleClickApplyButtonElement để nhận cả mã Offer và mã Shopify
    const originalHandleClickApply = instance.handleClickApplyButtonElement;
    if (typeof originalHandleClickApply === 'function') {
      instance.handleClickApplyButtonElement = async function(codeValue) {
        try {
          const errorEl = document.querySelector('.tl-discount-code-error');
          const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          if (!codeValue || !codeValue.trim()) {
            if (errorEl) errorEl.innerText = 'Empty code';
            return;
          }

          const trimmedCode = codeValue.trim();

          // Kiểm tra xem code có nằm trong Rule của App không (so sánh không phân biệt hoa thường)
          const matchedAppCode = (this.codeArr || []).find(
            c => c.toLowerCase() === trimmedCode.toLowerCase()
          );

          if (matchedAppCode) {
            // Là mã của App -> chuyển về hàm gốc xử lý tặng quà, popup,...
            return await originalHandleClickApply.call(this, matchedAppCode);
          }

          // Không nằm trong App -> Xử lý như mã Shopify thông thường
          const cartRes = await fetch(rootUrl + 'cart.js');
          const cartData = await cartRes.json();
          const currentCodes = (cartData.discount_codes || [])
            .filter(item => item.applicable)
            .map(item => item.code);

          const isAlreadyApplied = currentCodes.some(
            c => c.toLowerCase() === trimmedCode.toLowerCase()
          );

          if (isAlreadyApplied) {
            if (errorEl) errorEl.innerText = 'Code already applied';
            return;
          }

          if (currentCodes.length >= 5) {
            if (errorEl) errorEl.innerText = 'Maximum 5 discount codes allowed';
            return;
          }

          // Áp dụng qua Shopify Cart Update API
          const newCodes = [...currentCodes, trimmedCode];
          const updateRes = await fetch(rootUrl + 'cart/update.js?app=salepify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: newCodes.join(',') })
          });

          const updatedCart = await updateRes.json();
          const appliedItem = (updatedCart.discount_codes || []).find(
            item => item.code.toLowerCase() === trimmedCode.toLowerCase() && item.applicable
          );

          // Nếu Shopify không chấp nhận mã này (không tồn tại hoặc không đủ điều kiện)
          if (!appliedItem) {
            // Revert lại các mã trước đó
            await fetch(rootUrl + 'cart/update.js?app=salepify', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ discount: currentCodes.join(',') })
            });

            if (errorEl) errorEl.innerText = 'Code not existed';
            return;
          }

          // Thành công: xóa lỗi, reset ô input và cập nhật UI
          if (errorEl) errorEl.innerText = '';
          const codeBoxElement = document.querySelector('.tl-discount-code-box');
          if (codeBoxElement) codeBoxElement.value = '';

          if (typeof this.getGiftAdded === 'function') {
            await this.getGiftAdded();
          }
          if (typeof this.renderCodeApplied === 'function') {
            this.renderCodeApplied();
          }
          if (typeof this.refreshCart === 'function') {
            await this.refreshCart();
          }
        } catch (err) {
          console.error('[TL Discount Patch] Apply error, falling back:', err);
          try {
            return await originalHandleClickApply.call(this, codeValue);
          } catch (fallbackErr) {
            console.error('[TL Discount Patch] Fallback failed:', fallbackErr);
            const errorEl = document.querySelector('.tl-discount-code-error');
            if (errorEl) errorEl.innerText = 'Unable to apply code';
          }
        }
      };
    }
  }

  // Bắt sự kiện khi app khởi tạo window.tlDiscountCode
  try {
    let _instance = window.tlDiscountCode;
    Object.defineProperty(window, 'tlDiscountCode', {
      configurable: true,
      enumerable: true,
      get() {
        return _instance;
      },
      set(val) {
        _instance = val;
        try {
          patchTlDiscountCode(val);
        } catch (e) {
          console.error('[TL Discount Patch] Init error:', e);
        }
      }
    });

    if (_instance) {
      patchTlDiscountCode(_instance);
    }
  } catch (e) {
    console.error('[TL Discount Patch] Property definition error:', e);
  }

  // Polling backup phòng trường hợp script của theme chạy sau khi instance đã tạo
  let attempts = 0;
  const interval = setInterval(function() {
    attempts++;
    if (window.tlDiscountCode) {
      patchTlDiscountCode(window.tlDiscountCode);
    }
    if (attempts > 30 || (window.tlDiscountCode && window.tlDiscountCode._shopifyDiscountPatched)) {
      clearInterval(interval);
    }
  }, 200);
})();
